<script setup>
    import { ref, computed } from 'vue';
    import AiIntroPage from '@/components/result/ai-literacy/IntroPage.vue';

    const props = defineProps({
        studentData: Object
    });

    // API 데이터를 reportData 형식에 매핑
    const reportData = computed(() => {
        if (!props.studentData) {
            return {
                schoolName: "로딩중...",
                grade: "",
                className: "",
                studentName: "",
                studentNum: "",
                studentGender: "",
                schul_type: "",
            };
        }

        return {
            schoolName: props.studentData.schul_nm || "",  // 학교명
            grade: props.studentData.grade_code || "",     // 학년
            className: props.studentData.school_cls || "", // 반
            studentName: props.studentData.name || "",     // 학생이름
            studentNum: props.studentData.school_num || "", // 학생번호
            studentGender: props.studentData.gender === 'M' ? '남' : props.studentData.gender === 'F' ? '여' : '', // 성별
            schul_type: props.studentData.schul_type || "", // 학교급(추가)

        };
    });
</script>
<template>
    <div class="report-inner">         
        <AiIntroPage  
            reportType="student"         
           :reportData="reportData"
        />
    </div>
</template>